import type {
  ConfigurableServer,
  Except,
  ExcludeStringLiteral,
} from '@festina-life/core'

import type { ActionButtonProps } from '../../components/commandActions/types'

export type AnnotationCommandProps = Except<
  ActionButtonProps,
  'festinaComponent'
> & {
  festinaComponent: ExcludeStringLiteral<ConfigurableServer, 'collCalc'>
}

export const annotationMutatorComponent = {
  life: 'life',
  legalEntity: 'crm',
  moneyIn: 'moneyIn',
  moneyOut: 'moneyOut',
  unitLink: 'unitlink',
} as const satisfies Record<AnnotationCommandProps['festinaComponent'], string>
